'use client'

import Button from 'lib/components/Button/Button'
import Header from 'lib/components/Header/Header'

interface EmailSentProps {
  onBackToLogin: () => void
}

export default function EmailSent({ onBackToLogin }: EmailSentProps) {
  return (
    <div>
      <Header as="h2" className="type-body-3 mb-4">
        Check your email
      </Header>
      <p className="type-body-8 mb-4">
        Password reset information was sent to the email address on your
        account.
      </p>
      <Button
        className="!mt-4 w-full !type-body-11-bold md:!type-body-5"
        onClick={onBackToLogin}
      >
        Return to Login
      </Button>
    </div>
  )
}
